import React, { useState, useEffect } from 'react';
import Footer from '../Footer';

const JobPortal = () => {
  const [message, setMessage] = useState("Job Portal Coming Soon...");

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage((prevMessage) => 
        prevMessage === "Job Portal Coming Soon..." ? "Stay Tuned, We Are Almost Ready!" : "Job Portal Coming Soon..."
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div 
      style={{ 
        display: "flex", 
        flexDirection: "column", 
        minHeight: "100vh", // Ensures the container takes the full viewport height
      }}
    >
      <div style={{ flexGrow: 1, textAlign: "center" }}>
        <h1 
          style={{ 
            fontSize: "1.5rem", 
            marginBottom: "20px", 
            fontFamily: "Inter", 
            color: "#ff5733",
            fontWeight: "bold",
          }}
        >
          {message}
        </h1>
        <p style={{ fontSize: "1.2rem", color: "#555" }}>
          We're working hard to bring the best job opportunities to you! Stay tuned.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default JobPortal;
